import { InjectionKey, WritableComputedRef, ComputedRef } from 'vue'
import { RadioGroupProps } from '../radio-group'

type RadioGroupContextType = Omit<RadioGroupProps, 'modelValue' | 'disabled' | 'readonly'> & {
  /**
   * 当前绑定的值
   */
  value: WritableComputedRef<string | number>

  disabled: ComputedRef<RadioGroupProps['disabled']>

  readonly: ComputedRef<RadioGroupProps['readonly']>

  /**
   * 子级 change 事件
   * @param value
   */
  onChangeEvent: (value: string | number) => void
}

export const RADIO_GROUP_CONTEXT_KEY: InjectionKey<RadioGroupContextType> = Symbol('RadioGroup')
